import { render, staticRenderFns } from "./video-preview-config.vue?vue&type=template&id=3499b218&scoped=true"
import script from "./video-preview-config.vue?vue&type=script&lang=js"
export * from "./video-preview-config.vue?vue&type=script&lang=js"
import style0 from "./video-preview-config.vue?vue&type=style&index=0&id=3499b218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499b218",
  null
  
)

export default component.exports